import React, { useState } from 'react';
interface FAQItem {
  question: string;
  answer: string;
}
const faqs: FAQItem[] = [{
  question: '¿Sirve para todos los niveles de Pilates?',
  answer: 'Sí. El MegaPack cubre desde el alumno que nunca hizo Pilates hasta el avanzado con años de práctica. Los Tomos 1 y 2 tienen 3 bloques de nivel (Inicial, Intermedio y Avanzado) con variantes para cada ejercicio. El Tomo 3 agrega protocolos clínicos para condiciones especiales.'
}, {
  question: '¿Cómo recibo el material?',
  answer: '100% digital. Al completar la compra recibís un email con acceso a todos los PDFs en menos de 5 minutos. Lo podés abrir en el celular, la tablet o la computadora. Sin envío físico. Sin esperas.'
}, {
  question: '¿Funciona si trabajo con Reformer, con Mat o con los dos?',
  answer: 'Para los tres casos. El Tomo 1 es 100% Reformer. El Tomo 2 es 100% Mat y Props. Los demás incluyen variantes para ambas modalidades. Si solo tenés Mat — tenés más de 32 clases completas. Si tenés Reformer — tenés 24 más.'
}, {
  question: '¿Qué lo diferencia de buscar clases en YouTube o Instagram?',
  answer: 'YouTube te da ejercicios sueltos. El MegaPack te da sistemas completos: clases con estructura 5-10-30-5, cues verbales exactos, variantes, fichas de seguimiento y protocolos de seguridad. Es la diferencia entre ingredientes y una receta completa lista para usar.'
}, {
  question: '¿Tiene garantía real?',
  answer: 'Sí. 7 días completos. Si abrís los tomos, los usás en el estudio y no es lo que esperabas — te devolvemos el 100% sin ninguna pregunta. Escribinos a atencion.verticedigital@gmail.com y lo resolvemos en el día.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-[#0a0a0a] py-16 px-4" data-id="element-135">
      <div className="max-w-3xl mx-auto" data-id="element-136">
        <h2 className="text-3xl sm:text-4xl font-black text-white text-center mb-10" data-id="element-137">
          ❓ LO QUE MÁS NOS PREGUNTAN
        </h2>

        <div className="space-y-3 mb-10" data-id="element-138">
          {faqs.map((faq, i) => <div key={i} className={`rounded-xl border transition-colors ${openIndex === i ? 'border-[#A855F7] bg-[#0d0818]' : 'border-[#A855F7]/20 bg-black'}`} data-id="element-139">
              <button className="w-full text-left px-5 py-4 flex items-center justify-between gap-3" onClick={() => setOpenIndex(openIndex === i ? null : i)} aria-expanded={openIndex === i} data-id="element-140">
                <span className="text-white font-bold text-sm sm:text-base" data-id="element-141">
                  {faq.question}
                </span>
                <span className={`text-[#A855F7] text-xl flex-shrink-0 transition-transform ${openIndex === i ? 'rotate-45' : ''}`} data-id="element-142">
                  +
                </span>
              </button>
              {openIndex === i && <div className="px-5 pb-5" data-id="element-143">
                  <div className="h-px bg-[#A855F7]/20 mb-4" data-id="element-144" />
                  {faq.answer.split('\n\n').map((para, j) => <p key={j} className="text-gray-200 text-sm leading-relaxed mb-3 last:mb-0" data-id="element-145">
                      {para}
                    </p>)}
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}